import { render, staticRenderFns } from "./AltTahsilatTuruPicker.vue?vue&type=template&id=59e13744&scoped=true"
import script from "./AltTahsilatTuruPicker.vue?vue&type=script&lang=ts"
export * from "./AltTahsilatTuruPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e13744",
  null
  
)

export default component.exports